$component: 'dh-picture';

.#{$component} {
  display: block;
  width: 100%;
  position: relative;
  overflow: hidden;

  &--loading {
    animation: #{$component}-pulse 1.5s ease-in-out infinite;
  }

  &--fit-contain img {
    object-fit: contain;
  }

  &--fit-fill img {
    object-fit: fill;
  }

  &--fit-none img {
    object-fit: none;
  }

  &--fit-scale-down img {
    object-fit: scale-down;
  }

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  picture {
    display: block;
    width: 100%;
    height: 100%;
  }
}

@keyframes #{$component}-pulse {
  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.6;
  }
}
